import React from 'react';
import { Card, Placeholder } from 'react-bootstrap';

interface IOfferCardItemSkeletonProps {
    isAgencyCard?: boolean;
}

export function OfferCardItemSkeleton({ isAgencyCard = false }: IOfferCardItemSkeletonProps) {
    return (
        <div className="mb-4 w-100" aria-hidden="true">
            <Card className="offer-card-item overflow-hidden">
                <Card.Body className="placeholder-glow">
                    <div className="d-flex flex-column flex-md-row mb-3">
                        <div className="w-md-30">
                            <Placeholder className="skeleton skeleton-offer-card-image" />
                        </div>
                        <div className="d-flex flex-column ml-md-2 mt-3 mt-md-0 w-md-70">
                            <Placeholder xs={9} className="skeleton skeleton-title d-block mb-2" />
                            {isAgencyCard && <Placeholder className="skeleton skeleton-table-name d-block mb-2" />}
                            <Placeholder className="skeleton skeleton-date d-block mb-1" />
                            <Placeholder className="skeleton skeleton-date d-block" />
                            <div className="d-flex flex-wrap mt-2">
                                {Array.from({ length: 2 }).map((_, i) => (
                                    <div key={i} className="d-flex align-items-center my-1 mr-2">
                                        <Placeholder className="skeleton skeleton-platform-icon" />
                                        <Placeholder className="skeleton skeleton-table-cell ml-2" />
                                        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm ml-2" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <Card>
                        <div className="d-flex align-items-center justify-content-between p-2">
                            <div className="d-flex align-items-center">
                                <Placeholder className="skeleton skeleton-company-logo" />
                                <div className="d-flex flex-column ml-3">
                                    <Placeholder className="skeleton skeleton-table-name d-block" />
                                    <Placeholder className="skeleton skeleton-stat-label d-block mt-1" />
                                </div>
                            </div>
                            <Placeholder className="skeleton skeleton-price" />
                        </div>
                    </Card>
                    <Placeholder className="skeleton skeleton-table-name d-block mt-3 mb-2" />
                    <div className="d-flex">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <Placeholder key={i} className="skeleton skeleton-icon m-1" />
                        ))}
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="d-flex align-items-center">
                            <Placeholder className="skeleton skeleton-company-logo" />
                            <Placeholder className="skeleton skeleton-table-name ml-2" />
                            <Placeholder className="skeleton skeleton-badge ml-3 d-none d-md-inline-block" />
                        </div>
                        <Placeholder className="skeleton skeleton-action-btn skeleton-btn-sm ml-2" />
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}
